"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSeason = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Creates a new inactive season.
 *
 * ## Usage
 *
 * ```ts
 * const season: Pick<Season, 'name' | 'description' | 'icon'> = {
 * 	name: "Season III",
 * 	description: "It's a third racing season!",
 * 	icon: "http://http.cat/404.jpg",
 * };
 *
 * const {
 * 	acknowledged,
 * 	insertedId,
 * } = await sdk.createSeason({ season });
 * ```
 *
 * @param params.season - Object representing a season to be created.
 */
const createSeason = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { season } = params;
    const url = `${BASE_URL}/seasons`;
    const seasonResponse = yield axios_1.default.post(url, season, { validateStatus: () => true });
    const { status, data } = seasonResponse;
    if (status !== 201)
        throw new Error(data.error);
    return data;
});
exports.createSeason = createSeason;
